import React, { useState } from 'react';
import Image from 'next/image';

import Checkers from '../../../../../../helpers/class/Checkers';
import CustomModal from '../../../../../CustomModal';
import ModalServices from '../../modals/ModalServices';

export default function Ondemand ( props ) {
  const service = props.service;
  const is_modal = () => Checkers.objChildExists( props, 'modal' );

  const [ showModal, setShowModal ] = useState( false );

  const handleHide = () => {
    setShowModal( prev => !prev );
  }

  return (
    <>
      <div className="card-header p-0">
        {
          Checkers.isValidArray( service.service_images ) && Checkers.isValidString( service.service_images[0].service_image_square_thumb ) &&
            <Image
              layout={"responsive"}
              width={300}
              height={300}
              sizes={"40vw"}
              quality={"40"}
              className="image"
              objectFit={"cover"}
              src={service.service_images[0].service_image_square_thumb}
              alt={"service-image-" + service.service_id}
            />
        }

      </div>
      <div className="card-body pt-3 px-0 pb-0 text-left">
        {
          Checkers.isValidString( service.service_title ) &&
            <p>
              <span className="text-master">{service.service_title}</span>
            </p>
        }
      </div>
      {
        is_modal && showModal &&
          <CustomModal
            modalName={'service-'+service.service_id}
            className="slide_right"
            modalSize="lg"
            closeModal={() => {
              handleHide()
            }}
            show={showModal}
            Title={
              <>
                <h2 className="text-wrap text-left mt-0">{service.service_title}</h2>
                {
                  Checkers.isValidString( service.service_description ) &&
                          <p className="hint-text text-left">
                            {service.service_description}
                          </p>
                }
              </>
            }
          >
            <ModalServices service={props.service}/>
          </CustomModal>
      }
    </>

  )
}
